module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-header"
  }, [_c('div', {
    staticClass: "do-nav do-nav__left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": '/plan/' + _vm.schoolId,
      "active-class": "nav-item--selected"
    }
  }, [_c('span', {
    staticClass: "icon-calendar2"
  }), _vm._v("\n      Vagtplan\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": '/show',
      "active-class": "nav-item--selected"
    }
  }, [_c('span', {
    staticClass: "icon-clock"
  }), _vm._v("\n      Arbejdstider\n    ")])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "do-nav nav__right"
  }, [_c('li')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74fb6dcf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DoHeader.vue
// module id = 2014
// module chunks = 1